module.exports = __webpack_public_path__ + "img/CM-SL-24-Honda-Playful.201f2d4e.jpg";